import api from '../api'

const baseUrl = '/BizSchool/api/Basket'

const dadbanOrderProvider = {
  downloadExcel() {
    return api.get(`${baseUrl}/Download`)
  },
}

export default dadbanOrderProvider
